<template>
    <div :class="`form-image form-image-align-${localAlign}`">
        <div class="image-container">
            <img 
                :src="asset" 
                :style="{ 
                    width: width ? width + 'px' : 'auto', 
                    height: height ? height + 'px' : 'auto' 
                }"
                @load="onImageLoad"
                @error="onImageError"
                :class="{ 'loaded': imageLoaded, 'error': imageError }"
                alt="Form Image"
            />
            <div v-if="!imageLoaded && !imageError" class="image-loading">
                <div class="loading-spinner"></div>
                <span>Resim yükleniyor...</span>
            </div>
            <div v-if="imageError" class="image-error">
                <div class="error-icon">⚠</div>
                <span>Resim yüklenemedi</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "FormImage",
    props: {
        align: String,
        item: Object,
        asset: String,
        width: String,
        height: String,
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            localAlign: this.align || "center",
            imageLoaded: false,
            imageError: false,
        };
    },
    methods: {
        onImageLoad() {
            this.imageLoaded = true;
            this.imageError = false;
        },
        onImageError() {
            this.imageLoaded = false;
            this.imageError = true;
        }
    },
};
</script>
<style lang="scss" scoped>
/* Base FormImage Styles */
    .form-image {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.5rem, 1.5vw, 1rem) auto;
    padding: clamp(0.625rem, 1.5vw, 0.875rem);
    position: relative;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    
    background: linear-gradient(145deg, 
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
        background: linear-gradient(145deg, 
            rgba(255, 255, 255, 0.03) 0%,
            rgba(255, 255, 255, 0.02) 100%);
    }

    .image-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 3rem;
        border-radius: 0.5rem;
        overflow: hidden;
        background: rgba(255, 255, 255, 0.3);
        border: 1px solid rgba(209, 213, 219, 0.3);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
            background: rgba(255, 255, 255, 0.4);
            border-color: rgba(107, 114, 128, 0.3);
        }

        img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            border-radius: 0.375rem;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            opacity: 0;
            transform: scale(0.95);
            
            &.loaded {
                opacity: 1;
                transform: scale(1);
            }
            
            &.error {
                display: none;
            }
            
            &:hover {
                transform: scale(1.02);
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }
}

        .image-loading {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: clamp(0.5rem, 1.2vw, 0.75rem);
            color: rgba(107, 114, 128, 0.8);
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            font-weight: 500;
            padding: clamp(1rem, 2.5vw, 1.5rem);

            .loading-spinner {
                width: clamp(1.5rem, 3vw, 2rem);
                height: clamp(1.5rem, 3vw, 2rem);
                border: 2px solid rgba(99, 102, 241, 0.2);
                border-top: 2px solid var(--primary, #6366f1);
                border-radius: 50%;
                animation: spin 1s linear infinite;
            }

            span {
                text-align: center;
            }
        }

        .image-error {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: clamp(0.5rem, 1.2vw, 0.75rem);
            color: #ef4444;
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            font-weight: 500;
            padding: clamp(1rem, 2.5vw, 1.5rem);

            .error-icon {
                font-size: clamp(1.5rem, 3vw, 2rem);
                opacity: 0.8;
            }

            span {
                text-align: center;
            }
        }
    }
}

/* Left Alignment */
.form-image-align-left {
    .image-container {
        justify-content: flex-start;
        
        img {
            margin-right: auto;
}
    }
}

/* Right Alignment */
.form-image-align-right {
    .image-container {
        justify-content: flex-end;
        
        img {
            margin-left: auto;
        }
    }
}

/* Center Alignment (Default) */
.form-image-align-center {
    .image-container {
        justify-content: center;
        
        img {
            margin: 0 auto;
        }
    }
}

// Mobil optimizasyonları
@media (max-width: 768px) {
    .form-image {
        margin: clamp(0.25rem, 1vw, 0.5rem) auto;
        padding: clamp(0.5rem, 1.2vw, 0.75rem);
        
        .image-container {
            min-height: clamp(2.5rem, 6vw, 3rem);
            border-radius: 0.5rem;
            
            img {
                max-width: 100%;
                height: auto !important;
                width: auto !important;
                border-radius: 0.5rem;
                
                &:hover {
                    transform: scale(1.01);
                }
            }
            
            .image-loading {
                padding: clamp(0.75rem, 2vw, 1rem);
                gap: clamp(0.375rem, 1vw, 0.5rem);
                font-size: clamp(0.8rem, 1.8vw, 0.875rem);
                
                .loading-spinner {
                    width: clamp(1.25rem, 2.5vw, 1.5rem);
                    height: clamp(1.25rem, 2.5vw, 1.5rem);
                }
            }
            
            .image-error {
                padding: clamp(0.75rem, 2vw, 1rem);
                gap: clamp(0.375rem, 1vw, 0.5rem);
                font-size: clamp(0.8rem, 1.8vw, 0.875rem);
                
                .error-icon {
                    font-size: clamp(1.25rem, 2.5vw, 1.5rem);
                }
            }
        }
    }
}

@media (max-width: 480px) {
    .form-image {
        margin: 0.25rem auto;
        padding: 0.5rem;
        
        .image-container {
            min-height: 2.5rem;
            
            img {
                border-radius: 0.375rem;
                
                &:hover {
                    transform: none;
                }
            }
            
            .image-loading {
                padding: 0.75rem;
                gap: 0.375rem;
                font-size: 0.8rem;
                
                .loading-spinner {
                    width: 1.25rem;
                    height: 1.25rem;
                }
            }
            
            .image-error {
                padding: 0.75rem;
                gap: 0.375rem;
                font-size: 0.8rem;
                
                .error-icon {
                    font-size: 1.25rem;
                }
            }
        }
    }
}

/* Dark mode devre dışı - Her zaman açık tema kullan */

/* Loading Animation */
@keyframes spin {
    0% { 
        transform: rotate(0deg); 
    }
    100% { 
        transform: rotate(360deg); 
    }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
    .form-image,
    .image-container,
    .image-container img,
    .loading-spinner {
        transition: none;
        animation: none;
    }
    
    .image-container img:hover {
        transform: none;
    }
}

/* High Performance Mode */
.image-container {
    will-change: background-color, border-color;
    
    img {
        will-change: opacity, transform;
    }
    
    .loading-spinner {
        will-change: transform;
    }
}
</style>